import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { MechanismSection } from '../components/MechanismSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { WhatsInside } from '../components/WhatsInside';
import { PricingSection } from '../components/PricingSection';
import { WhoThisIsFor } from '../components/WhoThisIsFor';
import { FinalCTA } from '../components/FinalCTA';
import { useMetaPixel } from '../hooks/useMetaPixel';
export function SalesPage() {
  // Initialize Meta Pixel and track PageView on mount
  useMetaPixel();
  return <main className="min-h-screen w-full bg-white overflow-x-hidden" data-id="element-172">
      <Hero data-id="element-173" />
      <ProblemSection data-id="element-174" />
      <MechanismSection data-id="element-175" />
      <BenefitsSection data-id="element-176" />
      <WhatsInside data-id="element-177" />
      <PricingSection data-id="element-178" />
      <WhoThisIsFor data-id="element-179" />
      <FinalCTA data-id="element-180" />

      {/* Simple Footer */}
      <footer className="py-8 text-center text-[#8B9D83]/60 text-sm bg-[#F5F1E8]" data-id="element-181">
        <p data-id="element-182">
          © {new Date().getFullYear()} Fragrance-Free Home Reset. All rights
          reserved.
        </p>
      </footer>
    </main>;
}